var _ellipse, _ellipse2, _path, _path2, _rect, _rect2, _rect3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _circle, _circle2, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _circle3, _rect4, _rect5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _ellipse3, _ellipse4, _ellipse5, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _ellipse6, _path61, _path62, _path63;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoanAppGraphicDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 462.06,
    cy: 622.46,
    rx: 125.45,
    ry: 44.03,
    fill: "#A9CEF4"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 462.06,
    cy: 622.46,
    rx: 125.45,
    ry: 44.03,
    fill: "#fff",
    opacity: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M641.84,157.86c175.9,125.65,121.08,284.67,121.08,284.67C727.71,547.14,632.46,571.09,632.46,571.09s-169.21,55-398.28-95.52c0,0-87.18-62.84-91.45-133.17,0,0-4.85-37.24,49-47,27.07-4.92,39.86-36.51,24.08-59l-.75-1a29.12,29.12,0,0,0-11.75-9.44C177.06,214.26,75.55,164.73,98,100.64c0,0,23.23-133.6,212.54-64.28Z",
    fill: "#A9CEF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M641.84,157.86c175.9,125.65,121.08,284.67,121.08,284.67C727.71,547.14,632.46,571.09,632.46,571.09s-169.21,55-398.28-95.52c0,0-87.18-62.84-91.45-133.17,0,0-4.85-37.24,49-47,27.07-4.92,39.86-36.51,24.08-59l-.75-1a29.12,29.12,0,0,0-11.75-9.44C177.06,214.26,75.55,164.73,98,100.64c0,0,23.23-133.6,212.54-64.28Z",
    fill: "#fff",
    opacity: 0.7
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 123.4,
    y: 172.18,
    width: 295.69,
    height: 210.49,
    rx: 4.93,
    fill: "#21272D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 123.4,
    y: 172.18,
    width: 295.69,
    height: 210.49,
    rx: 4.93,
    opacity: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 128.41,
    y: 177.2,
    width: 285.67,
    height: 200.47,
    rx: 4.93,
    fill: "#A9CEF4",
    opacity: 0.48
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M341.41,142.11s-10,2.51-10,17.55v233H146V164.11a22.07,22.07,0,0,1,24-22.06l.68.06Z",
    fill: "#f2f2f2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M341.41,142.11s15-2.5,15,12.53v71.51s0,11.19,10,13.69H331.39V159.66S331.39,144.62,341.41,142.11Z",
    fill: "#ccc"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M199.57,142.11V102.59A5.59,5.59,0,0,1,205.16,97H391.53s-10,0-10,12.53V227.31s0,15-15,12.53c0,0-10-1.33-10-15.7v-69.5s0-15-15-12.53Z",
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M391.53,97s9.59-1.92,13.67,6a14,14,0,0,1,1.37,6.31l.17,62.87H381.5V109.54S381.5,97,391.53,97Z",
    fill: "#ccc"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M317.12,277.82H162.73a2.13,2.13,0,0,1-2.13-2.13V224a2.12,2.12,0,0,1,2.13-2.12H317.12a2.12,2.12,0,0,1,2.12,2.12v51.65A2.13,2.13,0,0,1,317.12,277.82ZM162.73,222.69a1.35,1.35,0,0,0-1.36,1.35v51.65a1.36,1.36,0,0,0,1.36,1.36H317.12a1.36,1.36,0,0,0,1.35-1.36V224a1.35,1.35,0,0,0-1.35-1.35Z",
    fill: "#e6e6e6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M301.32,235.22H173.52a.39.39,0,0,1-.39-.39.38.38,0,0,1,.39-.38h127.8a.38.38,0,0,1,.38.38A.39.39,0,0,1,301.32,235.22Z",
    fill: "#e6e6e6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M301.32,250.25H173.52a.39.39,0,1,1,0-.77h127.8a.39.39,0,0,1,0,.77Z",
    fill: "#e6e6e6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M301.32,262.78H173.52a.39.39,0,1,1,0-.77h127.8a.39.39,0,0,1,0,.77Z",
    fill: "#e6e6e6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M161,159.66v42.6h60.14v-42.6Zm56.38,40.09H164.75V162.16h52.62Z",
    fill: "#A9CEF4"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "171.28 199.75 186.05 172.19 196.07 189.73 201.08 179.7 213.09 199.75 171.28 199.75",
    fill: "#A9CEF4"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "186.05 172.19 184.41 172.19 169.14 199.75 171.28 199.75 186.05 172.19",
    fill: "#A9CEF4"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "186.05 172.19 184.41 172.19 169.14 199.75 171.28 199.75 186.05 172.19",
    opacity: 0.2
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "196.07 189.73 194.78 187.46 199.8 178.15 201.08 179.7 196.07 189.73",
    fill: "#A9CEF4"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "196.07 189.73 194.78 187.46 199.8 178.15 201.08 179.7 196.07 189.73",
    opacity: 0.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 196.34,
    cy: 170.84,
    r: 2.69,
    fill: "#A9CEF4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 196.34,
    cy: 170.84,
    r: 2.69,
    opacity: 0.2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M316.8,160H232.86a.39.39,0,0,1,0-.77H316.8a.39.39,0,0,1,0,.77Z",
    fill: "#e6e6e6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M316.8,173.9H232.86a.39.39,0,0,1-.38-.39.38.38,0,0,1,.38-.38H316.8a.38.38,0,0,1,.38.38A.39.39,0,0,1,316.8,173.9Z",
    fill: "#e6e6e6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M316,187.75H232.09a.39.39,0,0,1,0-.77H316a.39.39,0,0,1,0,.77Z",
    fill: "#e6e6e6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M316,201.61H232.09a.39.39,0,0,1-.38-.39.38.38,0,0,1,.38-.38H316a.38.38,0,0,1,.38.38A.39.39,0,0,1,316,201.61Z",
    fill: "#e6e6e6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M243.67,297.05H159.74a.39.39,0,1,1,0-.77h83.93a.39.39,0,1,1,0,.77Z",
    fill: "#e6e6e6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M243.67,310.91H159.74a.4.4,0,0,1-.39-.39.39.39,0,0,1,.39-.38h83.93a.38.38,0,0,1,.39.38A.39.39,0,0,1,243.67,310.91Z",
    fill: "#e6e6e6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M242.9,324.76H159a.39.39,0,1,1,0-.77H242.9a.39.39,0,1,1,0,.77Z",
    fill: "#e6e6e6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M242.9,338.62H159a.4.4,0,0,1-.39-.39.39.39,0,0,1,.39-.38H242.9a.38.38,0,0,1,.39.38A.39.39,0,0,1,242.9,338.62Z",
    fill: "#e6e6e6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M310,338.64h-5.33v-.77H310Zm-9.94,0H295.4v-.77H300Zm-9.21,0h-4.61v-.77h4.61Zm-9.22,0H277v-.77h4.61Zm-9.21,0h-4.61v-.77h4.61Zm-9.22,0h-4.61v-.77h4.61Zm-9.21,0h-1.16a3.33,3.33,0,0,1-3.07-2l.71-.3a2.55,2.55,0,0,0,2.36,1.56h1.16Zm58.62-3.34h-.77v-4.61h.77Zm-62.34-3.42h-.77v-4.61h.77Zm62.34-5.79h-.77v-4.61h.77Zm-62.34-3.42h-.77v-4.61h.77Zm62.34-5.8h-.77v-4.61h.77Zm-62.34-3.42h-.77v-4.61h.77Zm62.34-5.79h-.77v-4.61h.77Zm-62.34-3.42h-.77v-4.6h.77Zm61.36-5.61a2.54,2.54,0,0,0-2.35-1.55h-1.17v-.77h1.17a3.34,3.34,0,0,1,3.06,2Zm-8.13-1.55h-4.61v-.77h4.61Zm-9.22,0h-4.6v-.77h4.6Zm-9.21,0h-4.61v-.77H285Zm-9.22,0h-4.61v-.77h4.61Zm-9.21,0H262v-.77h4.61Zm-9.22,0h-4.59v-.77h4.6Z",
    fill: "#e6e6e6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M353.62,119.27H222.89a.39.39,0,0,1,0-.77H353.62a.39.39,0,0,1,0,.77Z",
    fill: "#f2f2f2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M353.62,133.13H222.89a.39.39,0,0,1-.38-.39.38.38,0,0,1,.38-.38H353.62a.38.38,0,0,1,.38.38A.39.39,0,0,1,353.62,133.13Z",
    fill: "#f2f2f2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 197.11,
    cy: 170.84,
    r: 2.69,
    fill: "#A9CEF4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 271.06,
    y: 302.82,
    width: 67.29,
    height: 50.83,
    fill: "#A9CEF4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 275.26,
    y: 305.81,
    width: 58.88,
    height: 44.85,
    fill: "#fff"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "282.57 350.66 299.1 317.77 310.31 338.7 315.92 326.74 329.36 350.66 282.57 350.66",
    fill: "#A9CEF4"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "299.1 317.77 297.27 317.77 280.18 350.66 282.57 350.66 299.1 317.77",
    fill: "#A9CEF4"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "299.1 317.77 297.27 317.77 280.18 350.66 282.57 350.66 299.1 317.77",
    opacity: 0.2
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "310.31 338.7 308.86 336 314.48 324.89 315.92 326.74 310.31 338.7",
    fill: "#A9CEF4"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "310.31 338.7 308.86 336 314.48 324.89 315.92 326.74 310.31 338.7",
    opacity: 0.2
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 310.61,
    cy: 316.17,
    rx: 3.01,
    ry: 3.21,
    fill: "#A9CEF4"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 310.61,
    cy: 316.17,
    rx: 3.01,
    ry: 3.21,
    opacity: 0.2
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 311.47,
    cy: 316.17,
    rx: 3.01,
    ry: 3.21,
    fill: "#A9CEF4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M728,495.92s-14,75.9-58.45,90.7c0,0-47.49,19.54-113.94,3.22a236.12,236.12,0,0,1-27.25-8.46s-59.24-22.19-77.9-53.06l-17.87-82.27,66.63-116.68s87.31-104.8,202.41-25.21C701.6,304.16,771.24,330.15,728,495.92Z",
    fill: "#ccc"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M715.2,383.76s-4,110.55-99.48,124.6a122.65,122.65,0,0,1-36.34-.51c-12.48-1.91-35.1-1.33-33.92,28.34,0,0,4,35.57,10.12,53.65a236.12,236.12,0,0,1-27.25-8.46s-59.24-22.19-77.9-53.06l-17.87-82.27L520.8,342.34s46-60.92,110.88-47.11C631.68,295.23,720.89,297.67,715.2,383.76Z",
    opacity: 0.2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M493.47,586.14v11.47s18.23,9.55,27.47-8.92C520.94,588.69,501.58,588.72,493.47,586.14Z",
    fill: "#f9b499"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M450.43,559.47a18,18,0,0,0,8.12,3.78c9.16,1.64,16.16-4.83,17.06-5.69l.4-9.19c-3,1-6.13,2.2-9.34,3.51C460.74,554.3,455.33,556.88,450.43,559.47Z",
    fill: "#f9b499"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M532.46,370.76s9.75-9.74,26-58.47l11.37-27.62s3.93-20.53,37.7-19.2l45.27-5.92s42.11,20.25,43.73,43v68.22S698.14,452,638,479.59c0,0,14.62-24.36-4.87-43.85l-16.82-17.63s-20.54,3-22.16-8.36c0,0,6.49-13-21.12-16.25l-26-9.74-9.21,1.72Z",
    fill: "#A9CEF4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M607.59,258.76v10s-1.58,8.78,10.25,11.71a26.13,26.13,0,0,0,14.7-.82c9.29-3.19,25.63-10.73,18.5-22.61,0,0-6.61-11.49-5.74-36.61C645.3,220.45,638.86,260.46,607.59,258.76Z",
    fill: "#f9b499"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M607.59,258.76v10s41.71-3.72,37.71-48.33C645.3,220.45,638.86,260.46,607.59,258.76Z",
    fill: "#f7a48b"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M623.3,418.41l15.42,19.65A37.92,37.92,0,0,1,647,461.74c-.18,14.93-9,17.85-9,17.85s14.62-26-4.87-43.85l-16.82-17.63Z",
    opacity: 0.2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M539,385.38S555.2,374,560.07,344.77l9.4-37.45h0a57.14,57.14,0,0,1,.29,34c-4.33,14.26-11.06,33.61-18.35,44.06l-4.33-1.62Z",
    opacity: 0.2
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M568.54,391.09,619.47,383a10.36,10.36,0,0,0,7.85-6c6.47-14.62,24.89-55.79,30.22-62.73,0,0-8.09,21.95-10.54,38.41,0,0-.83,37.58-28.45,34.34Z",
    opacity: 0.2
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M638,479.59s-40.6,6.5-87.71-3.24c0,0-18.37,77.14-22.76,92.09a6.57,6.57,0,0,0,0,3.95c1.17,3.5,2.74,11.19-4,15.71a10.46,10.46,0,0,1-2.83,1.33l-.39.11a12.85,12.85,0,0,1-4,.43c-6.71-.27-22.61-1.51-28.57-7.13a4,4,0,0,1-1.15-2.15,23.14,23.14,0,0,1,.31-10.13s-6.5-73.81,0-117.31c0,0,0-14.27,15.43-19.95,15-5.53,91-31.46,91-31.46s2.42,3,.79,7.91c0,0,.47,10.23,22.16,8.36l19.5,20.53S651,455.23,638,479.59Z",
    fill: "#21272D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M487,570.56c11.54.82,23.19,1.78,34.72.36.76-.13,1.52-.25,2.29-.36-6,1.68-12.3,1.85-18.49,1.79A129,129,0,0,1,487,570.56Z",
    opacity: 0.2
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M550.33,476.35V461.88c4.87,3.09,40.43,25.8,82.42,9.92a7.16,7.16,0,0,0,4.29-9c-4.26-12.47-14.73-39.55-26.92-44.7h6.23l19.49,20.53s15.2,15,2.2,40.95C638,479.59,603.93,486.09,550.33,476.35Z",
    opacity: 0.2
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M513,476.35c5,18.52,4,43-13.46,54.75a34.76,34.76,0,0,1-7.66,3.72c22.31-9.83,24.66-37.25,21.12-58.47Z",
    opacity: 0.2
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M517.84,523.45c1.07,3.76-1,8.6-4.87,9.75,2.37-3,3.55-6.1,4.87-9.75Z",
    opacity: 0.2
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M524,425.65l-22.4,8.46c-11.37,4.88-12.75,11.94-12.75,11.94l-32.73-.57c4.87,6.5,21.4,78,21.4,78a4.66,4.66,0,0,1,4.5.55v0s0,0,0,0a10.55,10.55,0,0,1,2.42,2.12l-.39,15c-.85,2.34-4,4.84-8.08,7.23-9.79,5.77-24.77,10.82-24.77,10.82-13,4.87-14.62-8.12-14.62-8.12-3.25-6.5,0-6.5,0-6.5L417.8,501a224.82,224.82,0,0,1-13.87-43.63A322.42,322.42,0,0,1,397.64,413c-3.25-14.62,42.23-26,42.23-26l3.25,11.37Z",
    fill: "#21272D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M524,425.65l-22.4,8.46c-11.37,4.88-12.75,11.94-12.75,11.94l-32.73-.57s-9.75-9.74-13-17.87c0,0,16.6,17.87,38.35,8.94,0,0,13.32-5.71,8.87-13.86a10,10,0,0,0-4.58-4.12l-42.64-20.19Z",
    opacity: 0.2
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M436.62,544.57c12.86-4,25.51-9.4,36.34-17.51,1.62-1.07,3-2.43,4.56-3.61-10.31,11.8-25.59,18.72-40.9,21.12Z",
    opacity: 0.2
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M484.48,526.16l-.39,15c-.85,2.34-4,4.84-8.08,7.23,5.15-7.41,6-23.65,6-24.35,0,0,0,0,0,0A10.55,10.55,0,0,1,484.48,526.16Z",
    opacity: 0.2
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M525.07,600.66a16.57,16.57,0,0,1-1.07,5.39c-3.6,14.36-25.65,34.35-25.65,34.35-21.12,17.87-37.62,12.19-37.62,12.19a4.67,4.67,0,0,1-1.7-1.33v0c-3.7-5,10.08-15.71,10.08-15.71a76.64,76.64,0,0,0,16.24-24.36c3.25-16.25,8.11-13.57,8.11-13.57,12.3,4.1,20.46-1.05,24.38-4.66a12.22,12.22,0,0,0,2.51-3.4l.39-.11C524.4,592.72,525.18,597.48,525.07,600.66Z",
    fill: "#A9CEF4"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M484.48,614a.77.77,0,0,1-.64-.34c-.11-.16-2.68-4-1.13-7.11,1.07-2.17,3.78-3.39,8.05-3.62s7.59.78,9.73,3a10.11,10.11,0,0,1,2.58,7.37.77.77,0,0,1-1.53-.14,8.72,8.72,0,0,0-2.17-6.18c-1.81-1.87-4.68-2.72-8.52-2.51-3.68.2-6,1.13-6.76,2.76-1.16,2.35,1,5.53,1,5.56a.77.77,0,0,1-.2,1.07A.76.76,0,0,1,484.48,614Z",
    fill: "#fff"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M498.35,624.93a.77.77,0,0,1-.69-.42c-3-6-6-6.58-6.05-6.58-7.43-1.71-10.24-.59-11.3.64-1.34,1.57-.4,4-.39,4a.77.77,0,0,1-1.43.58c-.05-.14-1.3-3.32.64-5.6s6.23-2.66,12.78-1.16c.09,0,3.74.62,7.13,7.4a.77.77,0,0,1-.35,1A.68.68,0,0,1,498.35,624.93Z",
    fill: "#fff"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M492.65,634.68a.78.78,0,0,1-.69-.43,14.24,14.24,0,0,0-5.33-6.15c-5.93-3-8.67-2.61-9.92-1.78a3.64,3.64,0,0,0-1.39,3,.77.77,0,1,1-1.54.1,5.19,5.19,0,0,1,2.07-4.43c2.31-1.53,6.17-1,11.47,1.69.15.07,3.49,1.79,6,6.83a.78.78,0,0,1-.34,1A.85.85,0,0,1,492.65,634.68Z",
    fill: "#fff"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M526.35,616.19l-7,10.08a91.14,91.14,0,0,1-20,20.86c-12.95,9.72-20.55,10-20.55,10-19,3.63-19.76-5.36-19.8-5.84a4.8,4.8,0,0,0,1.71,1.33s16.5,5.68,37.62-12.18c0,0,22.06-20,25.65-34.36a16.57,16.57,0,0,0,1.07-5.39l0,0c3.87,2.19,4.31,6,3.88,9A15,15,0,0,1,526.35,616.19Z",
    fill: "#21272D"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M477.52,571.27c-6.2,12.1-34.37,28-34.37,28-27.58,12.46-41.26,1.38-41.26,1.38a8.78,8.78,0,0,1-2.45-3.09,4.61,4.61,0,0,1-.18-3.41c1.81-5.42,13-9,13-9a57.54,57.54,0,0,0,6.33-3.87c.93-.63,1.84-1.28,2.72-1.93,2.94-2.13,5.47-4.16,6.57-5l.62-.52c.33-.39.65-.77,1-1.12,0,0,0,0,0,0,2.23-2.55,4.18-4.61,5.87-6.29,1.85-1.83,3.38-3.18,4.56-4.2l0,0a23.68,23.68,0,0,1,3.2-2.29c1.66.68,7.28-.41,7.28-.41,13.79,6.79,25.18-1.9,25.18-1.9l1.25,9Z",
    fill: "#A9CEF4"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M479.86,573.77a6.94,6.94,0,0,1-2.36,7.45l-19.11,15.44s-16.89,12.88-39.63,12.88h-.9c-21.75-.31-18.42-12-18.42-12a8.78,8.78,0,0,0,2.45,3.09s13.68,11.08,41.26-1.38c0,0,28.17-15.89,34.37-28A3.3,3.3,0,0,1,479.86,573.77Z",
    fill: "#21272D"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M437.44,590.33a.83.83,0,0,1-.74.89h-.08a.83.83,0,0,1-.81-.73c-.42-4.24-1.95-7.18-4.51-8.74-4.76-2.88-11.68-.16-11.75-.13a.75.75,0,0,1-1-.31c.93-.63,1.84-1.28,2.72-1.93,2.68-.67,7.18-1.22,10.81,1C435.16,582.19,437,585.53,437.44,590.33Z",
    fill: "#fff"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M446.63,584.32a.78.78,0,0,1-.26,0,.79.79,0,0,1-.76-.55c-1.47-4.35-3.79-7.32-6.94-8.83-4.74-2.28-9.83-.43-9.89-.41a.79.79,0,0,1-.9-.24l.62-.52c.33-.39.65-.77,1-1.12,0,0,0,0,0,0a15.16,15.16,0,0,1,9.86.84c3.58,1.69,6.19,5,7.78,9.78A.8.8,0,0,1,446.63,584.32Z",
    fill: "#fff"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M453.13,574.57a.8.8,0,0,1-.26,0,.81.81,0,0,1-.77-.55c-2.14-6.4-4.87-10-8.12-10.69-3.91-.81-7.41,2.94-7.44,3a.82.82,0,0,1-1.15.07l0,0c1.85-1.83,3.38-3.18,4.56-4.2l0,0a7.83,7.83,0,0,1,4.36-.37c3.86.81,7,4.77,9.32,11.76A.79.79,0,0,1,453.13,574.57Z",
    fill: "#fff"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "405.76 304.16 443.12 398.38 545.46 432.49 514.9 338.39 405.76 304.16",
    fill: "#A9CEF4"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "405.76 304.16 443.12 398.38 545.46 432.49 514.9 338.39 405.76 304.16",
    fill: "#fff",
    opacity: 0.4
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "405.76 304.16 410.63 302.54 517.84 335.03 514.9 338.39 405.76 304.16",
    fill: "#A9CEF4"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "405.76 304.16 410.63 302.54 517.84 335.03 514.9 338.39 405.76 304.16",
    opacity: 0.2
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "545.46 432.49 555.58 428.54 517.84 335.03 514.9 338.39 545.46 432.49",
    fill: "#A9CEF4"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "545.46 432.49 555.58 428.54 517.84 335.03 514.9 338.39 545.46 432.49",
    opacity: 0.3
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "554.42 425.89 612.05 414.62 547.08 383.76 538.25 385.1 554.42 425.89",
    fill: "#e6e6e6"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "555.58 428.54 616.35 418.11 612.05 414.62 554.42 425.89 555.58 428.54",
    fill: "#ccc"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M450.43,479.59c4,16,3.33,33.82-4.06,48.73.53-2,1.33-3.91,1.74-5.94,3.67-13.9,3.86-28.55,2.32-42.79Z",
    opacity: 0.2
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M525.07,600.66a16.57,16.57,0,0,1-1.07,5.39c-3.6,14.36-25.65,34.35-25.65,34.35-21.12,17.87-37.62,12.19-37.62,12.19a4.67,4.67,0,0,1-1.7-1.33c37,1.1,58.81-40,58.81-40,8.12-13,0-18.28,0-18.28a12.22,12.22,0,0,0,2.51-3.4l.39-.11C524.4,592.72,525.18,597.48,525.07,600.66Z",
    opacity: 0.2
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M477.52,571.27c-6.2,12.1-34.37,28-34.37,28-27.58,12.46-41.26,1.38-41.26,1.38a8.78,8.78,0,0,1-2.45-3.09,4.61,4.61,0,0,1-.18-3.41s9.75,12.71,33.3,5.12c0,0,29.32-12.36,44.3-32.71Z",
    opacity: 0.2
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M595.24,409.81a80.85,80.85,0,0,1-13.63,2.62,171,171,0,0,1-22.4.83,4.37,4.37,0,0,1-2.69-7.72A46.94,46.94,0,0,1,566,400h0a134.07,134.07,0,0,1,14.25-5.44C599.46,398.81,595.24,409.81,595.24,409.81Z",
    fill: "#f9b499"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M612,258.94a25.3,25.3,0,0,1-4.36-.16c-18.14-2.13-33.12-22.76-34.3-48.57a69,69,0,0,1,.09-8.15V202c1.72-24.08,15.86-43,33.9-43.86,20.06-.93,37.38,20.89,38.66,48.73S632.07,258,612,258.94Z",
    fill: "#f9b499"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M612,258.94a25.3,25.3,0,0,1-4.36-.16l-.06,0C634,252.33,638,227.82,638,227.82c3.25-16.24-7.89-16.68-7.89-16.68-32.24,1.2-42.8-15.94-42.8-15.94-10.28-11.51-13.32,3-13.91,6.78,1.72-24.08,15.86-43,33.9-43.86,20.06-.93,37.38,20.89,38.66,48.73S632.07,258,612,258.94Z",
    fill: "#f7a48b"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M646.17,239.19s-1.74-13.11-.87-18.75a10.18,10.18,0,0,1-4.82-6.23c-4.06-12-7.31-9.13-7.31-9.13-35.74,13-47.11-29.24-47.11-29.24-.82-2.49-2-2.52-3-2a.23.23,0,0,0-.1.07,5.66,5.66,0,0,0-1.42,1.38l-.13.17c-11.12,20.8-7.81,38.32-7.81,38.32s-11.92-.63-10.3-23.37c0,0,1.63-24.37,19.5-26,0,0,3.24-26.22,56.85-14.73,0,0,24.36,6.61,29.24,42.34C668.91,192.08,675.4,237.57,646.17,239.19Z",
    fill: "#21272D"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M640.36,213.12a.12.12,0,0,1-.24.06c-3.89-10.79-7-8.1-7-8.1-35.74,13-47.11-29.24-47.11-29.24-.82-2.49-2-2.52-3-2,2.87-2.24,9.3-4.58,17.6,8.45,0,0,5.09,9.93,20.58,15.67a39.76,39.76,0,0,0,12.56,2.27c3,.09,6.65,1,6.35,4.85C640.17,205.13,639.72,206.89,640.36,213.12Z",
    opacity: 0.2
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M657.54,209.14s9.74,18.68-11.37,30.05l-.87-18.74S655.91,226.19,657.54,209.14Z",
    opacity: 0.2
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 648.6,
    cy: 209.14,
    rx: 8.93,
    ry: 12.18,
    fill: "#f9b499"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M477.59,607.51a.81.81,0,0,1-.34-.08c-11.79-5.42-15.6-14.26-12.38-28.68,1.43-6.41.4-9.15-.73-10.33a3.57,3.57,0,0,0-3-1,.81.81,0,0,1-.28-1.6,5.27,5.27,0,0,1,4.48,1.51c2,2.12,2.41,6.1,1.13,11.8-3.06,13.72.37,21.75,11.48,26.86a.81.81,0,0,1,.4,1.07A.82.82,0,0,1,477.59,607.51Z",
    fill: "#fff"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M537.33,634.68c-12.94,0-20.1-6.43-23.19-20.85-1.38-6.44-3.48-8.51-5-9.11a3.67,3.67,0,0,0-3.22.32.76.76,0,0,1-1.07-.19.77.77,0,0,1,.2-1.07,5.2,5.2,0,0,1,4.66-.49c2.72,1.07,4.72,4.51,5.94,10.21,3,13.77,9.43,19.64,21.68,19.64a.77.77,0,0,1,0,1.54Z",
    fill: "#fff"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M581.64,412.41l0,0a171,171,0,0,1-22.4.83,4.37,4.37,0,0,1-2.69-7.72A46.94,46.94,0,0,1,566,400h0S568.05,408.53,581.64,412.41Z",
    fill: "#f7a48b"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanAppGraphicDark);
export default __webpack_public_path__ + "static/media/loanAppGraphicDark.05d06b62e616e7d02316824c88148ba8.svg";
export { ForwardRef as ReactComponent };